import api from "../../config/axios/configAxios";

export const activateAccount = async (token: string) => api.post(`/api/services/app/UserActivation/Activate?token=${token}`);